<template>
  <div id="app" class="initBgColor">
    <Layout>
      <router-view />
    </Layout>
  </div>
</template>

<script>
export default {
  computed: {
    shouldKeepAlive() {
      console.log("this.$route------->", this.$route.meta);
      return this.$route.meta.keepAlive;
    },
  },
  created() {
    this.$i18n.locale = "cn";
    this.$store.dispatch("setLanguage", "cn");
  },
  methods: {
    changeLanguage(lang) {},
  },
};
</script>

<style lang="scss">
#app {
  // text-align: center;
  color: #2a2a2a;
}

// .langSelect {
//   width: 6.25rem;
//   height: 2rem;
//   line-height: 2rem;
//   margin-left: 2rem;
//   .el-input__inner {
//     border-radius: 4px;
//     width: 6.25rem;
//     height: 2rem;
//     font-size: 0.875px;
//   }
// }
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2a2a2a;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.advertisement-box {
  width: 75rem;
  height: 17.6875rem;
  margin: 0 auto;
  margin-bottom: 3.125rem;
  .advertisement {
    display: flex;
    justify-content: row;
    align-items: center;
    background: #fff;
    .img-box {
      width: 15.875rem;
      height: 12.625rem;
      img {
        width: 15.875rem;
        height: 12.625rem;
      }
    }
    .cont-box {
      width: 59.125rem;
      height: 12.625rem;
      padding: 1rem 2.0625rem;
      p {
        width: 50.25rem;
        font-size: 1.25rem; //cs20px
        color: #2a2a2a;
        line-height: 2rem;
        font-weight: 400;
      }
    }
  }
  .flow-box {
    display: flex;
    justify-content: row;
    align-items: center;
    .flow-item {
      width: 8.875rem;
      text-align: center;
      img {
        width: 6.0625rem;
        height: 6.0625rem;
        margin-bottom: 0.875rem;
      }
      div {
        text-align: center;
      }
    }
  }
}
.card-box {
  width: 100rem;
  margin: 0 auto;
  margin-bottom: 3.125rem;
  background-color: #ffffff;
  padding: 1.25rem;
  box-shadow: 0px 3px 6px 1px rgba(38, 74, 124, 0.1);
  .card-desc {
    margin-bottom: 1.875rem;
    font-weight: 400;
    font-size: 1.25rem; //cs20px
    color: #2a2a2a;
    line-height: 22px;
    text-align: left;
  }
  .card {
    display: flex;
    justify-content: center;
    &:last-child {
      margin-right: 0;
    }
    .card-item {
      width: 23.4375rem;
      height: 15.625rem;
      background: #ffffff;
      box-shadow: 0px 3px 6px 1px rgba(174, 185, 209, 0.16);
      border: 1px solid #f1f1f1;
      margin-right: 1rem;
      text-align: center;
      padding: 3rem 3.5rem;
      img {
        width: 4.6875rem;
        height: 4.6875rem;
      }
      p {
        font-weight: 400;
        font-size: 1.25rem; //cs20px
        color: #2a2a2a;
        line-height: 2rem;
        text-align: center;
        margin-top: 1rem;
      }
    }
  }
}
</style>
